let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9jBjj")).then(() => parcelRequire('4nPqP'));